import React from "react";
import { useTranslation } from "react-i18next";

import { OpeningHoursType } from "@models/base/schedule.model";
import { OpeningHoursPropType } from "@models/components/organisation.model";

const OpeningHours: React.FC<OpeningHoursPropType> = ({ openingHoursData }) => {
  const { t } = useTranslation();
  return (
    <table className="fg-open-hour-listing-desc" data-testid="openingHours">
      {openingHoursData?.map((item: OpeningHoursType, index: number) => (
        <tr className="fg-open-hour" key={index} data-testid="open-hour">
          <td>
            <span className="fg-open-hour-day">{t(item?.day)}</span>
          </td>
          <td>
            {item?.window1OpenAt && (
              <span data-testid="days">
                {item?.window1OpenAt +
                  " " +
                  (item?.window1CloseAt ? "- " + item?.window1CloseAt : "")}
              </span>
            )}
            {item?.window2OpenAt && (
              <>
                ,
                <span data-testid="days">
                  {item?.window2OpenAt +
                    " " +
                    (item?.window2CloseAt ? "- " + item?.window2CloseAt : "")}
                </span>{" "}
              </>
            )}
          </td>
        </tr>
      ))}
    </table>
  );
};

export default OpeningHours;
